import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { BUTTON_SIZES } from "components/DesignComponents/Button/types/enums";
import CopyButton from "components/DesignComponents/CopyButton";
import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import CompanyDropdown from "components/QueryDropdown/CompanyDropdown";

import { ReceiveDeviceContentProps } from "./types";

const ReceiveDeviceContent = ({
    token,
    onCompanyChange
}: ReceiveDeviceContentProps) => {
    const { t } = useTranslation();

    return !token ? (
        <CompanyDropdown
            isRequired
            data-testid="receive-devices-token-company"
            labelLeft={t("Table##receiving company")}
            change={(_, val) => onCompanyChange(val)}
        />
    ) : (
        <>
            <BannerView
                bannerType={BannerType.Info}
                title={t(
                    "Dialog##device transfer##receive devices##token info"
                )}
            />

            <div
                css={css({
                    display: "flex",
                    alignItems: "flex-end",
                    marginTop: "16px",

                    "& > button": {
                        marginLeft: "8px"
                    }
                })}
            >
                <InputField
                    fullWidth
                    size={INPUT_FIELD_SIZES.Medium}
                    color="secondary"
                    value={token}
                    readOnly
                    labelLeft={t("Api tokens##generated token")}
                />

                <CopyButton size={BUTTON_SIZES.Normal} copiedValue={token} />
            </div>
        </>
    );
};
export default ReceiveDeviceContent;
